import React from 'react';
import './App.css';
import Navbar from './components/Navbarr';
import Home from './components/Home';
import About from './components/About';
import Board from './components/Board';
import Join from './components/Join';
import Footer from './components/Footer';
import Circles from './components/Circles';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Logistics from './components/Logistics';
import Media from './components/Media';
import Pr from './components/Pr';
import Hr from './components/Hr';
import Rd from './components/Rd';
import Tech from './components/Technical';


function App() {
  return (
    <div className="App">
        <Navbar />
        <Routes>
          <Route path='/' element={
            <>
              <Home />
              <About />
              <Board />
              <Tech />
              <Circles />
              <Join />
            </>
          }>
          </Route>
          <Route path='/logistics' element={<Logistics />}></Route>
          <Route path='/media' element={<Media />}></Route>
          <Route path='/pr' element={<Pr />}></Route>
          <Route path='/hr' element={<Hr />}></Route>
          <Route path='/rd' element={<Rd />}></Route>
        </Routes>
    <Footer />
    </div>
  );
}

export default App;